import React, { useState } from 'react';

function validateEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus(null);

    const nextErrors = {};
    if (!form.name.trim()) nextErrors.name = 'Please enter your name.';
    if (!validateEmail(form.email)) nextErrors.email = 'Please enter a valid email.';
    if (!form.message || form.message.trim().length < 10) nextErrors.message = 'Message should be at least 10 characters.';

    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    setLoading(true);
    try {
      // TODO: Hook up a real endpoint
      await new Promise((r) => setTimeout(r, 500));
      setStatus('Thanks! We received your message and will reply shortly.');
      setForm({ name: '', email: '', message: '' });
      setErrors({});
    } catch (err) {
      setStatus(err?.message || 'Unable to send message. Please try again later.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      padding: '48px 24px'
    }}>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ marginBottom: '32px', textAlign: 'center' }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#1f2937',
            margin: '0 0 12px 0'
          }}>Contact Sales & Support</h1>
          <p style={{
            fontSize: '16px',
            color: '#6b7280',
            margin: 0,
            lineHeight: '1.6'
          }}>Have questions? Send us a message and we'll get back within one business day.</p>
        </div>

        <form className="contact-form" onSubmit={handleSubmit} noValidate style={{
          backgroundColor: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '32px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#1f2937',
              marginBottom: '8px'
            }}>
              Name
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              aria-invalid={!!errors.name}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: errors.name ? '1px solid #dc2626' : '1px solid #d1d5db',
                borderRadius: '6px',
                fontFamily: 'inherit',
                boxSizing: 'border-box'
              }}
            />
            {errors.name && <div style={{ color: '#dc2626', fontSize: '13px', marginTop: '6px' }}>{errors.name}</div>}
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#1f2937',
              marginBottom: '8px'
            }}>
              Email
            </label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              aria-invalid={!!errors.email}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: errors.email ? '1px solid #dc2626' : '1px solid #d1d5db',
                borderRadius: '6px',
                fontFamily: 'inherit',
                boxSizing: 'border-box'
              }}
            />
            {errors.email && <div style={{ color: '#dc2626', fontSize: '13px', marginTop: '6px' }}>{errors.email}</div>}
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#1f2937',
              marginBottom: '8px'
            }}>
              Message
            </label>
            <textarea
              name="message"
              rows={6}
              value={form.message}
              onChange={handleChange}
              aria-invalid={!!errors.message}
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                border: errors.message ? '1px solid #dc2626' : '1px solid #d1d5db',
                borderRadius: '6px',
                fontFamily: 'inherit',
                boxSizing: 'border-box',
                resize: 'vertical'
              }}
            />
            {errors.message && <div style={{ color: '#dc2626', fontSize: '13px', marginTop: '6px' }}>{errors.message}</div>}
          </div>

          <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
              style={{
                padding: '10px 24px',
                backgroundColor: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Sending…' : 'Send'}
            </button>
            <a
              className="btn"
              href="#/"
              style={{
                padding: '10px 24px',
                backgroundColor: '#fff',
                color: '#374151',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              Cancel
            </a>
          </div>

          {status && (
            <div style={{
              padding: '12px 16px',
              borderRadius: '6px',
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              color: '#166534',
              fontSize: '14px'
            }}>
              {status}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
